import React, { PureComponent } from "react";

import { Col, Card, Row, Tabs,Pagination,Empty ,Button ,message} from 'antd';
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
// const { TabPane } = Tabs;
import './index.scss'
// require ("./index.css");

const { TabPane } = Tabs;



export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataList:[],
      dataInfo:{},
      activeKey:'1',
      defaultActiveKey:'1'
    };
  }

  componentDidMount() {
    this.getInfoList()
  }
  getInfoList =(data)=>{
    const { activeKey } = this.state
    let params = {
      current:1,
      size:6,
      categoryCode:'job003',
      ...data,
      
    }
    Http.get(Request.getInfoList(), params, obj => {
            // return
            if(obj.code == 200){
                console.log('obj.data.recordsobj.data.records',obj.data);
                
                this.setState({dataList:obj.data.records,dataInfo:obj.data})
            } else {
    
            message.error(obj.msg || obj.message || "请求失败，请重试");
            }
        });
  }
  renderListInfo=(data)=>{
    return(
        <Row gutter={24}>
            {
                 data && data.length ? data.map((item,index)=>{
                    return(
                    <Col span={8} key={index}>
                        <div className="persenInfo" key={index} onClick={()=>{this.props.history.push({pathname:'/entrance/businessBehalfDetail',state:{id:item.id}})}}>
                          <div className="left">
                            <img
                              src={item.image}
                              alt=""
                            />
                          </div>
                          <div className="right">
                            <div className="persenName">{item.title.split('--')[0]}</div>
                            <div className="persenCompany">{item.title.split('--')[1]}</div>
                            <div className="persenCompanyInfo">
                              {item.abstracts}
                            </div>
                          </div>
                        </div>
                    </Col>

                    )
                  }) : <Empty style={{width:'100%',height:'700px',display:'flex',justifyContent:'center',alignItems:'center'}}/>
                    
            }
        </Row>
     
    )
      
  }
  onChange = (e) => {
    console.log('222222',e);
    
    this.setState({activeKey:`${e}`,
    dataInfo:{},
  dataList:[]},()=>this.getInfoList())
  }
  sizeChange = (e)=>{
    this.getInfoList({current:e})
  }


  render() {
    const {dataInfo,dataList} =this.state
    const itemRender = (_, type, originalElement) => {
      if (type === 'prev') {
        return <a>上一页</a>;
      }
    
      if (type === 'next') {
        return <a>下一页</a>;
      }
    
      return originalElement;
    };
    return (
      <div>
        <div className='buinessBox'>
          <div className='conBox'>
                {this.renderListInfo(dataList)}
                <div className='Pagination'>
                  <span className='paginationBox' >
                    <Pagination
                        total={dataInfo.total}
                        showSizeChanger={false}
                        showQuickJumper
                        showTotal={(total) => `共 ${total} 条`}
                        itemRender={itemRender}
                        onChange={this.sizeChange}
                        defaultCurrent={1}
                      />
                      <Button style={{marginLeft:'10px'}}>确定</Button>
                  </span>
                </div>
          </div>
        </div>
      </div>
    );
  }
}
